var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMagnifyingGlass(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.687 15.815a5.08 5.08 0 010-10.16 5.08 5.08 0 010 10.16zm5.289-.973a6.629 6.629 0 001.438-4.146C17.414 6.998 14.401 4 10.707 4 7.013 4.02 4 7.017 4 10.715c0 3.699 3.013 6.696 6.688 6.696a6.775 6.775 0 004.14-1.44L18.854 20 20 18.852l-4.024-4.01z",
    fill: "#626696"
  })));
}
export default __webpack_public_path__ + "static/svg/magnifying-glass.svg";
export { SvgMagnifyingGlass as ReactComponent };